import { Stack, Typography, useTheme } from "@mui/material";
import { AvatarGroupCircle } from "components";
import { useState } from "react";
import type { ChatMember } from "shared/types/chatMembers";
import { ChatMembersDrawer } from "./components/ChatMembersDrawer";

export const AssigneesBlock = ({
  members,
  serviceId,
  isDisabled,
  serviceType,
}: {
  members: ChatMember[];
  serviceId: string;
  isDisabled?: boolean;
  serviceType: string;
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const getMemberNames = () => {
    const names = members.map(
      (member) => member.display_name || member.email || "Unknown",
    );
    if (names.length <= 2) return names.join(", ");
    return `${names.slice(0, 2).join(", ")} +${names.length - 2}`;
  };
  const membersWithName = members.map((member) => ({
    ...member,
    avatar_name: member.display_name || member.email || "Unknown",
  }));

  return (
    <>
      <Stack
        component="button"
        direction="row"
        onClick={() => setDrawerOpen(true)}
        sx={{
          bgcolor: "transparent",
          cursor: "pointer",
          gap: "8px",
          border: "1px solid transparent",
          p: "2px 4px",
          borderRadius: "8px",
          ":hover": {
            backgroundColor: theme.palette.neutral["005"],
            border: `1px solid ${theme.palette.neutral["010"]}`,
          },
        }}
      >
        <AvatarGroupCircle
          dataList={membersWithName}
          mappingKeys={{
            firstName: "avatar_name",
            lastName: "",
            src: "profile_pic",
          }}
        />
        <Stack
          sx={{
            justifyContent: "center",
          }}
        >
          <Typography
            maxWidth="260px"
            variant="subtitle1"
            noWrap
            textOverflow="ellipsis"
            sx={{ textTransform: "capitalize" }}
          >
            {getMemberNames()}
          </Typography>
          {/* {lastUpdated && (
                      <Typography variant="caption-3" color={theme.palette.lightBg.low}>
                        Last updated {dayjs(lastUpdated).fromNow()}
                      </Typography>
                    )} */}
        </Stack>
      </Stack>
      <ChatMembersDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onOpen={() => setDrawerOpen(true)}
        serviceId={serviceId}
        isDisabled={serviceType === "task" || isDisabled}
      />
    </>
  );
};
